var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M739.642 48.498c32.224-32.549 75.189-48.498 117.825-48.498 42.641 0 85.606 16.275 117.828 48.498 64.777 64.773 64.777 170.883 0 235.656l-637.312 626.899-337.861 112.947 112.62-338.187 626.9-637.315zM916.381 107.412c-16.597-16.6-37.751-24.412-58.914-24.412-21.153-0.325-42.31 8.137-58.585 24.087l-65.099 66.4c22.459 9.114 46.546 23.435 69.981 46.871 23.11 23.11 37.757 47.196 46.871 69.655l65.746-64.773c32.879-32.875 32.879-84.954 0-117.828zM678.776 243.794c15.298 1.302 37.757 7.161 65.749 35.153 28.318 28.318 34.177 50.777 35.804 66.075 0.839 10.067-0.244 12.687-0.979 14.463-0.12 0.291-0.231 0.56-0.323 0.835l-430.627 423.467c-9.114-20.506-23.435-42.314-44.918-63.797-21.157-21.157-42.965-35.478-63.797-44.593l424.153-430.485c1.832-0.945 3.944-2.033 14.938-1.118zM244.893 779.23c-28.643-28.644-49.475-33.852-62.494-34.828-0.651 0-0.733 0.081-0.773 0.122s-0.041 0.041-0.529-0.122l-26.691 79.746c8.137 6.184 16.275 13.019 24.086 20.832 8.137 8.137 14.973 16.273 21.483 24.414l79.421-26.367c-0.176-0.702-0.162-0.742-0.112-0.884 0.043-0.122 0.112-0.319 0.112-1.068-0.977-12.694-6.185-33.526-34.503-61.844z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.dfbaf395cf2a1896857146ae5bf0b5e3.svg";
export { ForwardRef as ReactComponent };